import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import Svg from '../svgIcon';

export const FreeBetList = (props) => {
    const {
            freeBets,
            selectedFreeBet,
            selectFreeBet,
            clearFreeBet,
            currencySign,
        } = props;

    const options = freeBets.map(freeBet => (
        <option
            key={freeBet.id}
            value={freeBet.id}
        >
            {currencySign}{parseFloat(freeBet.amount).toFixed(2)} Free Bet
        </option>
        ));

    const clearButton = selectedFreeBet ? (
        <button
            onClick={clearFreeBet}
            className="bs-freeBetList__clear-button"
        >
            <Svg
                iconName="remove"
                size="Medium"
            />
        </button>
        ) : null;

    return (
        <div className="bs-freeBetList">
            { clearButton }
            <select
                className="bs-freeBetList__list"
                required
                value={selectedFreeBet || ''}
                onChange={(e) => {
                    const { value } = e.target;
                    selectFreeBet(value)
                }}
            >
                <option
                    value=""
                    disabled
                >
                        Use a Free Bet?
                </option>
                {options}
            </select>
        </div>
    )
}

FreeBetList.defaultProps = {
    selectedFreeBet: null,
}

FreeBetList.propTypes = {
    selectedFreeBet: PropTypes.string,
    selectFreeBet: PropTypes.func.isRequired,
    clearFreeBet: PropTypes.func.isRequired,
    currencySign: PropTypes.string.isRequired,
    freeBets: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        minStake: PropTypes.number,
        maxStake: PropTypes.number,
        amount: PropTypes.number.isRequired,
    })).isRequired,

}

export default FreeBetList;



// WEBPACK FOOTER //
// /src/js/common/freeBetList/FreeBetList.jsx